<template>
  <div class="app-container" style="color: black; text-align: left">
    <div class="yeczdiv">
      <span style="
          border-bottom: 2px solid #2cafe7;
          font-size: 16px;
          color: black;
          padding-bottom: 4px;
          padding-left: 10px;
          padding-right: 10px;
        ">在线充值</span>
      <hr color="#dcdfe6" width="70%" />
      <div class="platcs-container">
        <el-button class="platcs" style="margin-left: 0" @click="addClass1(50)"
          :class="{ ptbgColors: platIndex === 50 }">
          ￥50金币
        </el-button>
        <el-button class="platcs" @click="addClass1(100)" :class="{ ptbgColors: platIndex === 100 }">
          ￥100金币
        </el-button>
        <el-button class="platcs" @click="addClass1(200)" :class="{ ptbgColors: platIndex === 200 }">
          <span>￥200金币</span>
        </el-button>
        <el-button class="platcs" @click="addClass1(300)" :class="{ ptbgColors: platIndex === 300 }">
          <span>￥300金币</span>
        </el-button>
        <el-button class="platcs" @click="addClass1(500)" :class="{ ptbgColors: platIndex === 500 }">
          <span>￥500金币</span>
        </el-button>
        <el-button class="platcs" @click="addClass1(800)" :class="{ ptbgColors: platIndex === 800 }">
          <span>￥800金币</span>
        </el-button>
        <el-button class="platcs" @click="addClass1(1000)" :class="{ ptbgColors: platIndex === 1000 }">
          <span>￥1000金币</span>
        </el-button>
      </div>

      <div class="zfxx">
        <!-- <svg width="22" height="22">
          <circle cx="11" cy="11" r="10" stroke="#2cafe7" stroke-width="2" fill="none" />
          <circle
            cx="11"
            cy="11"
            r="4"
            stroke="#2cafe7"
            stroke-width="2"
            fill="#2cafe7"
          />
        </svg> -->
        <div class="pay-method-selector">
          <div class="pay-method-item" :class="{ active: payType === 1 }" @click="payType = 1">
            <img :src="zfb_img" class="zfb_img_cs" />
            <span>支付宝</span>
          </div>
          <!-- <div class="pay-method-item" :class="{ active: payType === 2 }" @click="payType = 2">
            <img :src="wechat_img" class="zfb_img_cs" />
            <span>微信支付</span>
          </div> -->
        </div>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span>(充值后等待页面自动跳转回礼品网，请勿关闭！！！)</span>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-button type="primary" style="
            font-size: 13px;
            background-color: #0850fc;
            color: white;
            height: 38px;
            border-radius: 0.4em;
          " @click="alipay" :loading="rechargeLoading">立即充值</el-button>
      </div>
    </div>
    <div class="kamczdiv">
      <span style="
          border-bottom: 2px solid #2cafe7;
          font-size: 16px;
          color: black;
          padding-bottom: 4px;
          padding-left: 10px;
          padding-right: 10px;
        ">卡密充值</span>
      <hr color="#dcdfe6" width="70%" />
      <br />
      <el-input v-model="kami" style="width: 420px"></el-input>
      &nbsp;&nbsp;&nbsp;
      <el-button type="primary" style="
          font-size: 13px;
          background-color: #0850fc;
          color: white;
          height: 38px;
          border-radius: 0.4em;
        " @click="kamiPay">卡密充值</el-button>

      <br />
      <div class="czjl">
        <div style="margin-top: 20px">
          一次性充值<span class="blueSpan">50</span>金币, 免费升级为<span class="blueSpan">一级VIP</span>
        </div>
        <div>
          一次性充值<span class="blueSpan">200</span>金币, 免费升级为<span class="blueSpan">二级VIP</span>
        </div>
        <div>
          一次性充值<span class="blueSpan">300</span>金币, 免费升级为<span class="blueSpan">三级VIP</span>
        </div>
        <div>
          一次性充值<span class="blueSpan">500</span>金币, 免费升级为<span class="blueSpan">四级VIP</span>
        </div>
        <div v-show="!isShow">
          一次性充值<span class="blueSpan">800</span>金币, 免费升级为<span class="blueSpan">五级VIP</span>
        </div>
        <div v-show="isShow">
          一次性充值<span class="blueSpan">80000</span>金币, 免费升级为<span class="blueSpan">五级VIP</span>
        </div>
      </div>
      <br />
      <div style="
          margin-top: -214px;
          height: 20px;
          width: 100px;
          font-size: 18px;
          margin-left: 30px;
          padding-left: 13px;
          background-color: white;
        ">
        充值奖励
      </div>
    </div>
    <!-- 充值二维码弹出框 -->
    <el-dialog title="扫码支付" :visible.sync="dialogFormVisible" :show-close="false" style="padding: 0">
      <el-form ref="dataForm" label-width="30px"
        style="width: 100%; border-top: rgb(150 150 150) solid 1px; margin-top: -20px">
        <el-form-item>
          <div style="width: 180px; height: 180px; margin-left: -10px"
            v-bind:style="{ backgroundImage: 'url(' + qrCodeDataUrl + ')' }"></div>

          <span>此二维码支付1次有效</span>
        </el-form-item>
        <el-form-item>
          请您及时付款,以便订单尽快处理!请您在提交订单后5分钟内完成支付，否则订单会自动取消。
        </el-form-item>
        <el-form-item>
          订单号:<span style="color: red">{{ order_no }}</span>
        </el-form-item>
        <el-form-item> 付款成功会自己跳转，不要随意点击，请耐心等待... </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogFormVisible = false"> 关闭 </el-button> -->
        <el-button @click="closeDia"> 关闭 </el-button>
      </div>
    </el-dialog>
    <div ref="alipayWeb" v-html="alipayHtml"></div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import waves from "@/directive/waves"; // waves directive
import "@/assets/custom-theme/index.css"; // the theme changed version element-ui css
import QRCode from "qrcode";

export default {
  name: "czzx",
  directives: { waves },
  data() {
    return {
      platIndex: 50,
      // isLogin: false,
      payMoney: 50,
      payType: 1, // 1: 支付宝, 2: 微信支付
      zfb_img: require("@/assets/zfb.png"),
      wechat_img: require("@/assets/wechat_pay.png"),
      kami: "",
      dialogFormVisible: false,
      ewmImg: "",
      order_no: "",
      ewm_url: "",
      qrCodeDataUrl: "",
      intervalId: null,
      isShow: false,
      alipayHtml: "",
      alipayWeb: null,
      rechargeLoading: false,
    };
  },
  created() {
    //判断 登录userToken是否有效 userToken == '' ||
    // const userToken = Cookies.get("view_userToken");
    // if (userToken == undefined) {
    //   this.isLogin = false;
    //   this.$confirm("请先登录再使用！", "提示", {
    //     confirmButtonText: "确定",
    //   })
    //     .then(() => {
    //       // 重新导航到登录页面
    //       localStorage.clear();
    //       this.$root.removeCookies();
    //       this.$router.push({ path: "/login" });
    //     })
    //     .catch(() => {
    //       // 重新导航到首页
    //       localStorage.clear();
    //       this.$root.removeCookies();
    //       this.$router.push({ path: "/" });
    //     });
    //   return;
    // } else {
    //   this.isLogin = true;
    // }
    // this.selectOrder(); // 创建后立即执行一次查询
    // this.intervalId = setInterval(() => {
    //   this.selectOrder(); // 每分钟执行一次查询
    // }, 20000);
    const system_id = Cookies.get("view_system_id");
    if (system_id == "44" || system_id == 44) {
      this.isShow = true;
    }

    this.rechargeLoading = false;
  },
  activated() {
    this.rechargeLoading = false;
  },
  // mounted() {
  //   // 访问共享变量

  //   // 调用共享方法
  //   this.$root.getUserInfo();
  // },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId); // 清除定时器
    }
  },
  methods: {
    generateQRCode(url) {
      QRCode.toDataURL(url, { errorCorrectionLevel: "H" }, (err, url) => {
        if (err) {
          console.error(err);
        }
        this.qrCodeDataUrl = url;
      });
    },
    alipay() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        // this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      this.rechargeLoading = true;

      const url = this.$root.commonPreUrl + "/index/pay";
      let zfParams = {
        username: Cookies.get("view_userName"),
        // grade: Cookies.get("view_grade"),
        money: this.platIndex,
        type: 1, // 1: 支付宝, 2: 微信支付
        response_type: 'web',
        return_url: window.location.origin + "/#/cwmx/payReturn"
      };
     
      const res = axios.post(url, zfParams,
      {
        headers: {
          Authorization: "Bearer " + userToken,
        },
      });
      res.then((response) => {
          const resd = response.data;
          if (resd.code == 200) {
            this.alipayHtml = resd.data;
            this.$nextTick(() => {
              // setTimeout(() => {
                const form = this.$refs.alipayWeb.querySelector('form');
                if (form) {
                  this.rechargeLoading = false;
                  form.submit();
                } else {
                  console.error('未找到表单元素');
                  this.rechargeLoading = false;
                }
              // }, 100);
            });
          } else {
            this.$confirm(resd.message, "提示", {
              confirmButtonText: "确认",
              showCancelButton: false
            })
              .then(() => { })
              .catch(() => { });
            this.$confirm(resd.message, "提示", {
              confirmButtonText: "确认",
              showCancelButton: false
            })
            .then(() => { })
            .catch(() => { });
            this.rechargeLoading = false;
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          this.rechargeLoading = false;
          return;
        });
    },
    zfPay() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        // this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      this.selectOrder(); // 创建后立即执行一次查询
      this.intervalId = setInterval(() => {
        this.selectOrder(); // 每分钟执行一次查询
      }, 10000);

      const url = this.$root.commonPreUrl + "/index/youYunBaoPay";
      let zfParams = {
        username: Cookies.get("view_userName"),
        grade: Cookies.get("view_grade"),
        money: this.platIndex,
        type: this.payType, // 1: 支付宝, 2: 微信支付
      };
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: zfParams,
      });

      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == 200) {
            this.dialogFormVisible = true;
            this.qrCodeDataUrl = resd.data.qrcode;
            this.generateQRCode(this.qrCodeDataUrl);
            this.order_no = resd.data.order_no;
          } else {
            this.$confirm(resd.msg, "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => { })
              .catch(() => { });
            this.$confirm(resd.msg, "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => { })
              .catch(() => { });
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => { });
          }

          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },
    kamiPay() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        //  this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      const url = this.$root.commonPreUrl + "/index/zfPay";
      let kmParams = {
        kami: this.kami,
        type: 3,
      };
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: kmParams,
      });

      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == 200) {
            this.$notify({
              title: "成功",
              message: resd.message,
              type: "success",
              duration: 2000,
            });
          } else {
            this.$confirm(resd.message, "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => { })
              .catch(() => { });
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => { });
          }

          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },
    selectOrder() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        //  this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      const url = this.$root.commonPreUrl + "/index/selectOrder";
      let params = {
        order_no: this.order_no,
      };
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: params,
      });

      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == 200) {
            this.dialogFormVisible = false;
            this.$root.getUserBalance();
          }
          // else {
          //  this.$confirm(resd.msg, "提示", {
          //     confirmButtonText: "确认",
          //     showCancelButton: false, //是否显示取消按钮
          //   })
          //     .then(() => {
          //     })
          //     .catch(() => {});
          // }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => { });
          }

          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },
    addClass1: function (i) {
      this.platIndex = i;
      this.payMoney = i;
    },
    closeDia() {
      this.$confirm("关闭窗口，会导致充值失败，请等待窗口自动关闭！如充值失败，请联系客服补充。", "提示", {
        confirmButtonText: "确认",
        showCancelButton: false, //是否显示取消按钮
      })
        .then(() => {
          this.dialogFormVisible = false;
        })
        .catch(() => { });
    }
  },
};
</script>

<style scoped>
.yeczdiv {
  height: 180px;
}

.platcs-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 15px;
}

.platcs {
  /* width: 90px; */
  /* height: 35px; */
  border: 1px solid #2cafe7;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
}

.ptbgColors {
  background-color: #2cafe7;
  /* font-size: 16px; */
  /* font-weight: bold; */
  color: white;
  /* padding-top: 2px; */
  /* text-align: center; */
}

.zfb_img_cs {
  height: 2vw;
  width: 2vw;
}

.zfxx {
  margin-top: 25px;
  display: flex;
  align-items: center;
  /* 垂直居中 */
}

.pay-method-selector {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pay-method-item {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border: 2px solid transparent;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s;
}

.pay-method-item:hover {
  border-color: #2cafe7;
}

.pay-method-item.active {
  border-color: #2cafe7;
  background-color: #e6f7ff;
}

.pay-method-item span {
  font-size: 14px;
  color: #333;
}

.czjl {
  margin-top: 40px;
  width: 80vw;
  height: 180px;
  border: #dcdfe6 1px solid;
  padding-left: 15px;
  width: 70%;
}

.czjl div {
  /* height: 30px; */
  margin-top: 10px;
}

.blueSpan {
  color: #0850fc;
  font-weight: bold;
}

.el-dialog_body {
  padding: 0;
  text-align: left;
}

.ewm_img_div {
  width: 20vw;
  min-height: 22.5vh;
  /* border: #0850fc 1px solid; */
  /* background-color: #d5e1ff; */
  color: rgb(37, 37, 37);
  margin-left: 73px;
  margin-top: 8px;
  text-align: left;
}

.ewm_img {
  width: 18vw;
  height: 18vw;
}
</style>



// WEBPACK FOOTER //
// src/views/cwmx/czzx/index.vue